import service from '@/store/services/admin_orders_history-service';

const state = {
    adminOrdersHistoryList: {},
    adminOrdersHistoryByClientId: {},
    tadOrdersList: {},
    tadOrdersListByClientId: {},
    brokenOrderInfo: {},
    orderHistoryInfo: {},
    tabSearchOrdersList: {},
    workersTabPeriod: {},
    historyByPeriod: {},
    historyByStatuses: {}
};

const mutations = {
    SET_ADMIN_ORDERS_LIST: (state, adminOrdersHistoryList) => {
        state.adminOrdersHistoryList = adminOrdersHistoryList;
    },
    SET_ADMIN_TAB_ORDERS_LIST: (state, tadOrdersList) => {
        state.tadOrdersList = tadOrdersList;
    },
    SET_ADMIN_ORDERS_HISTORY_BY_CLIENT_ID: (state, adminOrdersHistoryByClientId) => {
        state.adminOrdersHistoryByClientId = adminOrdersHistoryByClientId;
    },
    SET_ADMIN_TAB_ORDERS_BY_CLIENT_ID: (state, tadOrdersListByClientId) => {
        state.tadOrdersListByClientId = tadOrdersListByClientId;
    },
    SET_BROKEN_ORDER_INFO: (state, brokenOrderInfo) => {
        state.brokenOrderInfo = brokenOrderInfo;
    },
    SET_ORDER_HISTORY_INFO: (state, orderHistoryInfo) => {
        state.orderHistoryInfo = orderHistoryInfo;
    },
    SET_SEARCH_BY_ORDER_NUMBER_HISTORY_INFO: (state, tabSearchOrdersList) => {
        state.tabSearchOrdersList = tabSearchOrdersList;
    },
    SET_WORKERS_PERIOD_HISTORY_INFO: (state, workersTabPeriod) => {
        state.workersTabPeriod = workersTabPeriod;
    },
    SET_HISTORY_BY_PERIOD_INFO: (state, historyByPeriod) => {
        state.historyByPeriod = historyByPeriod;
    },
    SET_HISTORY_BY_STATUSES_INFO: (state, historyByStatuses) => {
        state.historyByStatuses = historyByStatuses;
    },

};

const actions = {
    adminOrdersHistoryList({commit, dispatch}, params) {
        return service.getOrdersHistoryList(params)
            .then(({adminOrdersHistoryList}) => {
                commit('SET_ADMIN_ORDERS_LIST', adminOrdersHistoryList);
            });
    },
    tadOrdersList({commit, dispatch}, params) {
        return service.getPaginatedTabOrdersList(params)
            .then(({tadOrdersList}) => {
                commit('SET_ADMIN_TAB_ORDERS_LIST', tadOrdersList);
            });
    },
    tabSearchOrdersList({commit, dispatch}, params) {
        return service.getTabSearchOrdersList(params)
            .then(({tabSearchOrdersList}) => {
                commit('SET_SEARCH_BY_ORDER_NUMBER_HISTORY_INFO', tabSearchOrdersList);
            });
    },
    adminOrdersHistoryByClientId({commit, dispatch}, params) {
        return service.getOrdersHistoryByClientId(params)
            .then(({adminOrdersHistoryByClientId}) => {
                commit('SET_ADMIN_ORDERS_HISTORY_BY_CLIENT_ID', adminOrdersHistoryByClientId);
            });
    },
    tadOrdersListByClientId({commit, dispatch}, params) {
        return service.getTabOrdersByClientId(params)
            .then(({tadOrdersListByClientId}) => {
                commit('SET_ADMIN_TAB_ORDERS_BY_CLIENT_ID', tadOrdersListByClientId);
            });
    },
    brokenOrderInfo({commit, dispatch}, params) {
        return service.getBrokenOrderInfo(params)
            .then(({brokenOrderInfo}) => {
                commit('SET_BROKEN_ORDER_INFO', brokenOrderInfo);
            });
    },
    orderHistoryInfo({commit, dispatch}, { order_id, archive = false}) {
        return service.getOrderHistoryInfo( order_id, archive)
            .then(({orderHistoryInfo}) => {
                commit('SET_ORDER_HISTORY_INFO', orderHistoryInfo);
            });
    },
    workersTabPeriod({commit, dispatch}, params) {
        return service.getTabByWorkerPeriod(params)
            .then(({workersTabPeriod}) => {
                commit('SET_WORKERS_PERIOD_HISTORY_INFO', workersTabPeriod);
            });
    },
    historyByPeriod({commit, dispatch}, params) {
        return service.getTabHistoryByPeriod(params)
            .then(({historyByPeriod}) => {
                commit('SET_HISTORY_BY_PERIOD_INFO', historyByPeriod);
            });
    },
    historyByStatuses({commit, dispatch}, params) {
        return service.getTabHistoryByStatuses(params)
            .then(({historyByStatuses}) => {
                commit('SET_HISTORY_BY_STATUSES_INFO', historyByStatuses);
            });
    },

};

const getters = {
    adminOrdersHistoryList: state => state.adminOrdersHistoryList,
    adminOrdersHistoryByClientId: state => state.adminOrdersHistoryByClientId,
    tadOrdersList: state => state.tadOrdersList,
    tadOrdersListByClientId: state => state.tadOrdersListByClientId,
    brokenOrderInfo: state => state.brokenOrderInfo,
    orderHistoryInfo: state => state.orderHistoryInfo,
    tabSearchOrdersList: state => state.tabSearchOrdersList,
    workersTabPeriod: state => state.workersTabPeriod,
    historyByPeriod: state => state.historyByPeriod,
    historyByStatuses: state => state.historyByStatuses,
};

const adminOrdersHistory = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default adminOrdersHistory;